// import React, { useContext } from "react";
// import { Route, Redirect } from "react-router-dom";
// import { UserContext } from "../contexts/UserContext";

// const ProtectedRoute = ({ component: Component, adminOnly, ...rest }) => {
//   const { state } = useContext(UserContext);

//   return (
//     <Route
//       {...rest}
//       render={(props) => {
//         if (!state) {
//           return <Redirect to="/signin" />;
//         }
//         if (adminOnly && state.role !== "admin") {
//           return <Redirect to="/" />;
//         }
//         return <Component {...props} />;
//       }}
//     />
//   );
// };

// export default ProtectedRoute;

import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { UserContext } from "../contexts/UserContext";

const ProtectedRoute = ({ component: Component, adminOnly, ...rest }) => {
  const { state } = useContext(UserContext);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!state) {
          return <Redirect to="/signin" />;
        }
        if (adminOnly && state.role !== "admin") {
          return <Redirect to="/" />;
        }
        return <Component {...props} />;
      }}
    />
  );
};

export default ProtectedRoute;
